import { Base } from "../../framework/base";
import { CalendarTaskCategoryListItem } from "../calendarTaskCategory/calendarTaskCategoryListItem";
import { CalendarTaskEditItem } from "./calendarTaskEditItem";
var CalendarTaskEdit = /** @class */ (function () {
    function CalendarTaskEdit(obj) {
        this.item = new CalendarTaskEditItem(obj ? obj.item : null);
        this.categories = Base.getTypedArray(obj ? obj.categories : null, CalendarTaskCategoryListItem);
        this.canSaveCalendarTask = obj && obj.canSaveCalendarTask || false;
        this.canRemoveCalendarTask = obj && obj.canRemoveCalendarTask || false;
        this.canShareCalendarTasks = obj && obj.canShareCalendarTasks || false;
        this.userIsIsSystemAdmin = obj && obj.userIsIsSystemAdmin || false;
    }
    return CalendarTaskEdit;
}());
export { CalendarTaskEdit };
